import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxComponent } from '@shared/genericUI/components/checkbox/checkbox.component';
import { DropdownComponent } from '@shared/genericUI/components/dropdown/dropdown.component';
import { EupDropdownComponent } from '@shared/genericUI/components/eup-dropdown/eup-dropdown.component';
import { EupButtonComponent } from '@shared/genericUI/components/eupButton/eupButton.component';
import { InputComponent } from '@shared/genericUI/components/input/input.component';
import { ItemAdderComponent } from '@shared/genericUI/components/itemAdder/itemAdder.component';
import { TextareaComponent } from '@shared/genericUI/components/textarea/textarea.component';
import { TextSendComponent } from '@shared/genericUI/components/textSend/textSend.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RestrictInputDirective } from '@shared/restrictInput/restrictInput.directive';
import { CaretAnimatedComponent } from '@shared/genericUI/components/caretAnimated/caretAnimated.component';
import {LoadableDropdownComponent} from '@shared/genericUI/components/loadable-dropdown/loadable-dropdown.component';
import { TlkCheckboxComponent } from "@itero/ui-toolkit-angular/checkbox";
import { TlkSlideToggleComponent } from "@itero/ui-toolkit-angular/slide-toggle";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TlkRadioButtonComponent } from '@itero/ui-toolkit-angular/radio-button';
import { TlkTextInputComponent } from '@itero/ui-toolkit-angular/text-input';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { SharedDirectivesModule } from '@shared/directives/shared-directives.module';

const genericUiComponents = [
	CheckboxComponent,
	DropdownComponent,
	EupDropdownComponent,
	EupButtonComponent,
	InputComponent,
	ItemAdderComponent,
	TextareaComponent,
	TextSendComponent,
	CaretAnimatedComponent,
	LoadableDropdownComponent
];

const tlkComponents = [
	TlkSlideToggleComponent,
	TlkCheckboxComponent,
	TlkRadioButtonComponent,
	TlkTextInputComponent,
	TlkButtonComponent
];

@NgModule({
	declarations: [
		...genericUiComponents,
		RestrictInputDirective,
	],
	imports: [
		...tlkComponents,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		BsDropdownModule,
		SharedDirectivesModule,
	],
	exports: [
		genericUiComponents,
		tlkComponents,
		SharedDirectivesModule,
	]
})
export class GenericUIModule { }
